import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import DispatchList from "../../Components/Lists/DispatchList";
import DispatchItemAdderModal from "../DispatchItemAdder/index";
import socketIO from "../../Socket/socketIO";
import { toast } from "react-toastify";

import {
  fetchDispatch,
  createDispatch,
  reorderDispatches,
  dispatchCreateDispatch,
  dispatchDeleteDispatch,
  dispatchUpdateDispatch,
  dispatchReorderDispatches,
  dispatchReorderJobs,
  teamJobsDeleted,
  updateVisibility,
} from "./actions";
import { selectTeams, selectTeam } from "./selectors";
import { toggleItemModal, changeItemModalTab } from "../../Redux/UI/actions";
import moment from "moment";

export class Dispatch extends React.Component {
  static propTypes = {
    teams: PropTypes.array,
    open: PropTypes.bool,
    onToggleModal: PropTypes.func,
    onChangeModalTab: PropTypes.func,
    itemModalActiveTab: PropTypes.number,
    activeTeamID: PropTypes.number,
    onReorderDispatches: PropTypes.func,
  };

  componentDidMount() {
    const { onFetchDispatch } = this.props;
    const storedDate = localStorage.getItem("casa-date");
    onFetchDispatch(storedDate ? storedDate : null);
  }

  formatDate = (date) => {
    return moment(date).format("YYYY-MM-DD");
  };

  initSocketEvent = () => {
    const {
      onDispatchCreateDispatch,
      onDispatchDeleteDispatch,
      onDispatchUpdateDispatch,
      onDispatchReorderDispatches,
      onDispatchReorderJobs,
      onTeamJobsDeleted,
      onUpdateVisibility,
      date,
    } = this.props;
    socketIO().on(`create-${date}`, (obj) => {
      onDispatchCreateDispatch(obj.team, obj.teamJobs);
    });
    socketIO().on(`delete-${date}`, (obj) => {
      onDispatchDeleteDispatch(obj.id);
    });
    socketIO().on(`update-${date}`, (obj) => {
      onDispatchUpdateDispatch(obj.team, obj.teamJobs);
    });
    socketIO().on(`reorder-team-${date}`, (obj) => {
      onDispatchReorderDispatches(obj.teamID, obj.startIndex, obj.endIndex);
    });
    socketIO().on(`delete-teamJob-${date}`, (obj) => {
      onTeamJobsDeleted(obj.teamID, obj.jobsToRemove);
    });
    socketIO().on(`reorder-teamJob-${date}`, (obj) => {
      onDispatchReorderJobs(
        obj.teamID,
        obj.jobID,
        obj.startIndex,
        obj.endIndex
      );
    });
    socketIO().on(`paste-team-${date}`, (obj) => {
      onDispatchCreateDispatch(obj.teams, obj.teamJobs);
    });
    socketIO().on(`update-teams-visibility-${date}`, (obj) => {
      onUpdateVisibility(obj.date, obj.visible);
    });

    // Centralized error handling
    socketIO().on("error", (err) => {
      toast.error("Error: " + (err?.error || "Unknown error"));
    });
  };
  clearSocketEvent = (date) => {
    if (socketIO()) {
      socketIO().off(`create-${date}`);
      socketIO().off(`delete-${date}`);
      socketIO().off(`update-${date}`);
      socketIO().off(`reorder-team-${date}`);
      socketIO().off(`delete-teamJob-${date}`);
      socketIO().off(`reorder-teamJob-${date}`);
      socketIO().off(`paste-team-${date}`);
      socketIO().off(`update-teams-visibility-${date}`);
      socketIO().off("error");
    }
  };
  componentDidUpdate(prevProps) {
    if (prevProps.date !== this.props.date) {
      this.clearSocketEvent(prevProps.date);
      this.initSocketEvent();
    }
  }

  render() {
    const {
      date,
      teams,
      open,
      onToggleModal,
      onChangeModalTab,
      itemModalActiveTab,
      activeTeam,
      onCreateDispatch,
      onReorderDispatches,
      user,
    } = this.props;

    const isAdmin = user && user.userType === "admin";
    const className = isAdmin ? "" : "basic";
    if (!date) {
      return <div />;
    }

    return (
      <div id="dispatch-app" className={className}>
        <DispatchList
          teams={teams}
          handleReorderDispatch={onReorderDispatches}
          onAddClick={onCreateDispatch}
          userType={user.userType}
        />
        {isAdmin && (
          <DispatchItemAdderModal
            open={open}
            handleToggleModal={onToggleModal}
            handleChangeModalTab={onChangeModalTab}
            activeTab={itemModalActiveTab}
            team={activeTeam}
          />
        )}
      </div>
    );
  }
}

Dispatch.defaultProps = {
  auth: {},
};

const mapStateToProps = (state) => ({
  teams: selectTeams(state),
  open: state.ui.itemModalOpen,
  itemModalActiveTab: state.ui.itemModalActiveTab,
  activeTeamID: state.ui.activeTeamID,
  activeTeam: selectTeam(state, state.ui.activeTeamID),
  date: state.dispatch.date,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchDispatch: (date) => dispatch(fetchDispatch(date)),
  onToggleModal: () => dispatch(toggleItemModal(0)),
  onChangeModalTab: (index) => dispatch(changeItemModalTab(index)),
  onCreateDispatch: () => dispatch(createDispatch()),

  onDispatchCreateDispatch: (team, teamJobs) =>
    dispatch(dispatchCreateDispatch(team, teamJobs)),
  onDispatchDeleteDispatch: (id) => dispatch(dispatchDeleteDispatch(id)),
  onDispatchUpdateDispatch: (team, teamJobs) =>
    dispatch(dispatchUpdateDispatch(team, teamJobs)),

  onReorderDispatches: (teamID, startIndex, endIndex) =>
    dispatch(reorderDispatches(teamID, startIndex, endIndex)),
  onDispatchReorderDispatches: (teamID, startIndex, endIndex) =>
    dispatch(dispatchReorderDispatches(teamID, startIndex, endIndex)),
  onDispatchReorderJobs: (teamID, jobID, startIndex, endIndex) =>
    dispatch(dispatchReorderJobs(teamID, jobID, startIndex, endIndex)),
  onTeamJobsDeleted: (teamID, jobsToRemove) =>
    dispatch(teamJobsDeleted(teamID, jobsToRemove)),
  onUpdateVisibility: (date, visible) =>
    dispatch(updateVisibility(date, visible)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Dispatch);
